import React from 'react';
import ImageLoader from 'components/image-loader';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';

import type { PreConstructionProject } from '@zoocasa/pre-construction';

interface Props {
  listing: PreConstructionProject;
  className?: string;
  testId?: string;
}

export default function PreConEmptyCoverImage({ listing, className, testId }: Props) {
  return (
    <div data-testid={testId}>
      <ImageLoader 
        src="/next/assets/images/precon-coming-soon.png" 
        alt={`${listing.title} | Zoocasa`} 
        className={buildClassName(styles.component, className)}
        height="13em" 
      />
    </div>
  );
}
